/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLocationDot,
  faClock,
  faPersonHiking,
  faArrowTrendUp,
  faUsers,
  faGlobe,
} from '@fortawesome/pro-regular-svg-icons';
import H1 from './H1';
import ShowMeMore from './ShowMeMore';
import RichTextParser from './RichTextParser';
import { useMediaQuery } from 'beautiful-react-hooks';
import { FormatDuration } from '../utils/dateFormater';

export default function BasicTripInfo({ trip }) {
  const getLanguages = () => {
    return trip?.attributes?.languages?.data?.map((language) => language?.attributes?.name) || [];
  };
  const duration = trip?.attributes?.duration;
  const isMobile = useMediaQuery('(max-width: 425px)');
  return (
    <div className="mt-8 w-full md:mt-12">
      <div className="md:px-0 lg:px-0 xl:px-0 2xl:px-0">
        <H1 text={trip?.attributes?.title} className=" mt-12 text-dark-800" />
        <div className="mt-6 font-sans text-base text-dark-800 xl:mt-6 xl:text-xl">
          <RichTextParser>{trip?.attributes?.summary}</RichTextParser>
        </div>
      </div>

      <div
        className={`${isMobile ? 'hero-image-component w-screen' : ''
          } mt-8 gap-6 bg-dark-50 md:px-0 md:py-0 lg:rounded-xl lg:px-0 lg:py-0 xl:mt-8 xl:flex xl:flex-col xl:px-8 xl:py-8 2xl:px-8 2xl:py-8`}
      >
        <div className="grid grid-cols-2 gap-3 p-6 font-sans text-base md:grid md:grid-cols-2 md:gap-5 md:p-8  lg:grid-cols-4 lg:p-0">
          <div>
            <span className="flex">
              <FontAwesomeIcon icon={faLocationDot} className="mt-1 mr-2 w-3 text-dark-500" />
              <p className="text-dark-500">Destination</p>
            </span>

            <p className="pl-5 text-base text-dark-900 ">
              {trip?.attributes?.start_region}, {trip?.attributes?.start_state}
            </p>
          </div>
          <div>
            <span className="flex ">
              <FontAwesomeIcon icon={faClock} className="mt-1 mr-2 w-3 text-dark-500" />
              <p className="text-dark-500">Duration</p>
            </span>
            <p className="pl-5 text-base text-dark-900">{FormatDuration(duration)}</p>
          </div>
          <div>
            <span className="flex">
              <FontAwesomeIcon icon={faPersonHiking} className="mt-1 mr-2 w-3 text-dark-500" />
              <p className="text-dark-500">Distance</p>
            </span>
            <p className="pl-5 text-base text-dark-900">{trip?.attributes?.distance} km</p>
          </div>
          <div>
            <span className="flex">
              <FontAwesomeIcon icon={faArrowTrendUp} className="mt-1 mr-2 w-3 text-dark-500" />
              <p className="text-dark-500">Difficulty</p>
            </span>
            <p className="pl-5 text-base text-dark-900">
              {trip?.attributes?.difficulty?.data?.attributes?.name}
            </p>
          </div>
          <div>
            <span className="flex">
              <FontAwesomeIcon icon={faUsers} className="mt-1 mr-2 w-3 text-dark-500" />
              <p className="text-dark-500">Group size</p>
            </span>
            <p className="pl-5 text-base text-dark-900">{trip?.attributes?.group_size}</p>
          </div>
          <div>
            <span className="flex">
              <FontAwesomeIcon icon={faGlobe} className="mt-1 mr-2 w-3 text-dark-500" />
              <p className="text-dark-500">Language</p>
            </span>
            <p className="pl-5 text-base text-dark-900">{getLanguages().join(' / ')}</p>
          </div>
        </div>
      </div>
      <ShowMeMore title="What to expect" text={trip?.attributes?.why_go} />
    </div>
  );
}
